import React from 'react';
import Dashboard from '../../component/Dashboard';

const DashboardPage = () => {
  return (
    <div className="dashboard_page_wrapper">
      <Dashboard />
    </div>
  );
};
export default DashboardPage;
